export type MergeArraysUniqueObjectsParams = {
  existingArray: object[],
  newArray: object[],
  objectMatchKey: string,
}

function mergeArraysUniqueObjects(params: MergeArraysUniqueObjectsParams) {
  const { existingArray, newArray, objectMatchKey = 'id' } = params

  // @ts-expect-error TS7053
  const newDataKeys = newArray.map(data => data[objectMatchKey])

  const mergedData = [
    ...newArray,
    // @ts-expect-error TS7053
    ...existingArray.filter(existingData => !newDataKeys.includes(existingData[objectMatchKey])),
  ]

  return mergedData
}

export default mergeArraysUniqueObjects
